import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { InfiniteScrollGridResponse, ReviewLogLookupDto, SuccessResponse } from '@interfaces/central-monitoring';
import { ObservationType } from '@interfaces-clean/observations.interface';
import {
    CreateSiteReviewLog,
    DeleteSiteReviewLog,
    UpdateSiteReviewLog,
    BulkUpdateStudyReviewLog,
} from '@interfaces-clean/review-logs.interface';
import { getData, postData } from '@apis/rest-client';

const siteReviewLogUrl = 'CentralMonitoring/SiteReviewLog';

const SiteReviewLogsApi = {
    useSave: (studyRef: string) => {
        return useSWRMutation(
            `${siteReviewLogUrl}/Add/${studyRef}`,
            (url: string, { arg }: { arg: CreateSiteReviewLog }) => {
                return postData<CreateSiteReviewLog, SuccessResponse>(url, { arg, timeout: 30000 });
            },
        );
    },
    useUpdate: (studyRef: string) => {
        return useSWRMutation(
            `${siteReviewLogUrl}/Update/${studyRef}`,
            (url: string, { arg }: { arg: UpdateSiteReviewLog }) => {
                return postData<UpdateSiteReviewLog, SuccessResponse>(url, { arg, timeout: 30000 });
            },
        );
    },
    useDelete: (studyRef: string) => {
        return useSWRMutation(
            `${siteReviewLogUrl}/Delete/${studyRef}`,
            (url: string, { arg }: { arg: DeleteSiteReviewLog }) => {
                return postData<DeleteSiteReviewLog, boolean>(url, { arg, timeout: 30000 });
            },
        );
    },
    useBulkUpdate: (studyRef: string) => {
        return useSWRMutation(
            `${siteReviewLogUrl}/BulkUpdate/${studyRef}`,
            (url: string, { arg }: { arg: BulkUpdateStudyReviewLog }) => {
                return postData<BulkUpdateStudyReviewLog, boolean>(url, { arg, timeout: 30000 });
            },
        );
    },
    useGet: (studyRef: string) => {
        return useSWRMutation(`${siteReviewLogUrl}/${studyRef}`, (url: string, { arg }: { arg: string }) => {
            return getData<InfiniteScrollGridResponse>(`${url}/${arg}`, { timeout: 30000 });
        });
    },

    useLookupReviewLogsForObservation: (studyRef: string, observationId: string, observationType: ObservationType) => {
        const url =
            observationType === ObservationType.Site
                ? `${siteReviewLogUrl}/Get/${studyRef}/ReviewLogsForObservation/${observationId}`
                : null;

        return useSWR<ReviewLogLookupDto[]>(url, getData);
    },
};

export default SiteReviewLogsApi;
